// extracted by mini-css-extract-plugin
export default {"navbarShadow":"Navbar_navbarShadow__yhtHl","logo":"Navbar_logo__a4pDX"};